var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("TitleBar"), _c("div", {
    staticClass: "main"
  }, [_c("div", {
    staticClass: "input-con"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value,
      expression: "value"
    }],
    ref: "inputs",
    attrs: {
      type: "text",
      placeholder: ""
    },
    domProps: {
      value: _vm.value
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.value = $event.target.value;
      }, function ($event) {
        $event.stopPropagation();
        return _vm.input(_vm.value);
      }]
    }
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isEmpty,
      expression: "!isEmpty"
    }],
    staticClass: "clear-icon",
    on: {
      click: _vm.clear
    }
  }, [_c("img", {
    attrs: {
      src: require("../../../assets/images/close.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "search",
    on: {
      click: function click($event) {
        return _vm.getResult(_vm.value);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("Search")))])]), _vm.isResults ? _c("div", {
    staticClass: "results"
  }, [_c("van-tabs", {
    ref: "tabs",
    attrs: {
      background: "#000",
      "title-active-color": "rgba(255,255,255)",
      "title-inactive-color": "rgba(255,255,255,0.60)",
      swipeable: ""
    },
    on: {
      change: _vm.tabChange
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_vm._l(_vm.arr, function (item) {
    return _c("van-tab", {
      key: item,
      attrs: {
        title: item,
        name: item
      }
    });
  }), _c("transition", {
    attrs: {
      name: _vm.transitionName
    }
  }, [_c("router-view", {
    staticClass: "Router",
    attrs: {
      inputValue: _vm.inputValue
    },
    on: {
      tabChange: _vm.tabChange
    }
  })], 1)], 2)], 1) : _vm._e(), _vm.findList.length > 0 ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isInput && !_vm.isResults,
      expression: "isInput && !isResults"
    }],
    staticClass: "menu-list"
  }, _vm._l(_vm.findList, function (item) {
    return _c("span", {
      key: item,
      on: {
        click: function click($event) {
          return _vm.getResult(item);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0) : _vm._e(), _vm.historySearchList.length > 0 ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isInput && !_vm.isResults,
      expression: "!isInput && !isResults"
    }],
    staticClass: "search-history"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("span", [_vm._v("Search History")]), _c("div", {
    on: {
      click: _vm.clearHistory
    }
  }, [_c("img", {
    attrs: {
      src: require("../../../assets/images/close.png"),
      alt: ""
    }
  })])]), _c("div", {
    staticClass: "search-history-list"
  }, _vm._l(_vm.historySearchList, function (item) {
    return _c("span", {
      key: item,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.getResult(item);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0)]) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isInput && !_vm.isResults,
      expression: "!isInput && !isResults"
    }],
    staticClass: "search-history"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("HotSearches")))])]), _c("div", {
    staticClass: "search-history-list"
  }, _vm._l(_vm.hotSearchList, function (item) {
    return _c("span", {
      key: item.bkId,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.getResult(item.keyword);
        }
      }
    }, [_vm._v(_vm._s(item.keyword))]);
  }), 0)]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isInput && !_vm.isResults,
      expression: "!isInput && !isResults"
    }],
    staticClass: "search-history"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("HotTopic")))]), _c("div", {
    staticClass: "more",
    on: {
      click: _vm.toAllTopic
    }
  }, [_c("span", {
    staticStyle: {
      "margin-right": "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t("AllTopics")))]), _c("img", {
    attrs: {
      src: require("../../../assets/images/Search-more.png"),
      alt: ""
    }
  })])]), _c("div", {
    staticClass: "search-history-list"
  }, _vm._l(_vm.hotTopicList, function (item) {
    return _c("span", {
      key: item.topicId,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toTopic(item.topicId);
        }
      }
    }, [_vm._v(_vm._s(item.content))]);
  }), 0)])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };